module.exports = __webpack_public_path__ + "img/voltage1.bcc5dd11.png";